import React, { useEffect, useState, useContext } from "react";
import { useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { MDBRow, MDBCol } from "mdbreact";

import "./UKMRVReportSummary.scss";

import { Input } from "abs-ui-components";

import UKMRV_Report_Summary from "./UKMRVReportSummary.json";
import { REPORT_SUMMMERY_HEADERS } from "../../../../../../constants/ReportSummaryTable_header";
import CustomTable from "../../../../../../common/customTable/CustomTable";
import {
	getReportSummaryByType,
	getReportSummeryTable,
} from "../../../../../../services/ChildReportService";
import { roundOff } from "../../../../../../services/utilities";
import { ClaimsContext } from "../../../../../../services/ClaimsService";
import { ClaimType } from "../../../../../../constants/claims";

const UKMRVReportSummary = () => {
	const { userHasClaim } = useContext(ClaimsContext);
	const { control, setValue } = useForm();
	const [UKMRVReportSummary, setUkumrvReportSummary] = useState([]);
	const [ukmrvReportSummaryTable, setukmrvReportSummaryTable] = useState([]);
	const [responseStatus, setResponseStatus] = useState(false);
	const [isLoading, setLoading] = useState(false);

	const reportDetails = useSelector(
		(state) => state?.reports?.selectedReportDetails
	);
	const user = useSelector((state) => state.userInfo.userData);

	const transportWorkFields = [
		"TotalTransportWorkMt",
		"TotalTransportWorkM3",
		"TotalTransportWorkDwt",
		"TotalTransportWorkPax",
		"FuelConsPerTransportWorkMt",
		"FuelConsPerTransportWorkM3",
		"FuelConsPerTransportWorkDwt",
		"FuelConsPerTransportWorkPax",
		"Co2EmissionsPerTransportWorkMt",
		"Co2EmissionsPerTransportWorkM3",
		"Co2EmissionsPerTransportWorkDwt",
		"Co2EmissionsPerTransportWorkPax",
		"FuelConsTransportOnLadenMt",
		"FuelConsTransportOnLadenM3",
		"FuelConsTransportOnLadenDwt",
		"FuelConsTransportOnLadenPax",
		"Co2EmissionsPerTransportWorkOnLadenMt",
		"Co2EmissionsPerTransportWorkOnLadenM3",
		"Co2EmissionsPerTransportWorkOnLadenDwt",
		"Co2EmissionsPerTransportWorkOnLadenPax",
	];

	const fetchEumrvReportSummaryTabledata = async () => {
		try {
			setLoading(true);
			const response = await getReportSummeryTable(
				reportDetails?.ReportMstId
			);
			if (response) {
				setukmrvReportSummaryTable(response.data.Data);
			}
			setLoading(false);
		} catch (error) {
			setLoading(false);
			console.error(error);
		}
	};

	useEffect(() => {
		const fetchUkmrvReportSummary = async () => {
			try {
				const ukmrvReportSummaryData = await getReportSummaryByType(
					reportDetails?.ReportMstId
				);

				const response = ukmrvReportSummaryData.data.Data;
				if (response[0]) {
					setResponseStatus(true);
				}
				UKMRV_Report_Summary.forEach((field) => {
					if (response[0][field.name]) {
						setValue(field.name, response[0][field.name]);
					}
					if (response[0][field.accessor_key_1]) {
						setValue(
							field.accessor_key_1,
							response[0][field.accessor_key_1]
						);
					}
					if (response[0][field.accessor_key_2]) {
						setValue(
							field.accessor_key_2,
							response[0][field.accessor_key_2]
						);
					}
					if (response[0][field.accessor_key_3]) {
						setValue(
							field.accessor_key_3,
							response[0][field.accessor_key_3]
						);
					}
				});

				const filteredSummary = UKMRV_Report_Summary.filter((field) => {
					if (transportWorkFields.includes(field.name)) {
						return (
							response[0][field.name] !== "" &&
							response[0][field.name] !== null
						);
					}
					return true;
				});
				setUkumrvReportSummary(filteredSummary);
			} catch (error) {}
		};
		fetchUkmrvReportSummary();
		fetchEumrvReportSummaryTabledata();
	}, [setValue]);

	const renderUkmrvReportData = () => {
		return (
			<>
				{responseStatus
					? UKMRVReportSummary.map((field, index) => (
							<div key={`uk-mrv-${index}`}>
								<MDBRow className="ukmrv-container mt-3">
									<MDBCol className="col-1"></MDBCol>
									<MDBCol className="col-5 pl-0">
										<label>
											<p
												className={`label-font ${
													transportWorkFields.includes(
														field.name
													)
														? "ml-3 pl-3"
														: "ml-2"
												}`}
											>
												{field.label}
											</p>
										</label>
									</MDBCol>

									{!field.remove && (
										<>
											<MDBCol className="col-2 pl-0">
												<Controller
													name={field.name}
													control={control}
													defaultValue={
														field.value || ""
													}
													render={({ field }) => (
														<Input
															type={field.type}
															{...field}
															value={roundOff(
																field.value ||
																	0,
																3,
																3
															)}
															autoFocus={false}
															className="report-input-ukmrv"
															readOnly
															title={
																field.value || 0
															}
														/>
													)}
												/>
											</MDBCol>
										</>
									)}
									{field.restrict && (
										<>
											<MDBCol className="col-2 pl-0"></MDBCol>
										</>
									)}

									{userHasClaim(ClaimType.VIEW_CALCULATED_DIFF_MATERIALITY) && (
										<>
											{field.calculated && (
												<>
													<MDBCol className="col-1 pl-0">
														<Controller
															name={
																field.accessor_key_1
															}
															control={control}
															defaultValue={
																field.value ||
																""
															}
															render={({
																field,
															}) => (
																<Input
																	type={
																		field.type
																	}
																	{...field}
																	value={roundOff(
																		field.value ||
																			0,
																		3,
																		3
																	)}
																	autoFocus={
																		false
																	}
																	className="report-input-ukmrv"
																	readOnly
																	title={
																		field.value ||
																		0
																	}
																/>
															)}
														/>
													</MDBCol>
												</>
											)}
											{field.diff && (
												<>
													<MDBCol className="col-1 pl-0">
														<Controller
															name={
																field.accessor_key_2
															}
															control={control}
															defaultValue={
																field.value ||
																""
															}
															render={({
																field,
															}) => (
																<Input
																	type={
																		field.type
																	}
																	{...field}
																	value={roundOff(
																		field.value ||
																			0,
																		3,
																		3
																	)}
																	autoFocus={
																		false
																	}
																	className="report-input-ukmrv"
																	readOnly
																	title={
																		field.value ||
																		0
																	}
																/>
															)}
														/>
													</MDBCol>
												</>
											)}
											{field.materiality && (
												<>
													<MDBCol className="col-1 pl-0">
														<Controller
															name={
																field.accessor_key_3
															}
															control={control}
															defaultValue={
																field.value ||
																""
															}
															render={({
																field,
															}) => (
																<Input
																	type={
																		field.type
																	}
																	{...field}
																	value={roundOff(
																		field.value ||
																			0,
																		3,
																		3
																	)}
																	autoFocus={
																		false
																	}
																	className="report-input-ukmrv"
																	readOnly
																	title={
																		field.value ||
																		0
																	}
																/>
															)}
														/>
													</MDBCol>
												</>
											)}
										</>
									)}
								</MDBRow>
							</div>
					  ))
					: UKMRV_Report_Summary.map((field, index) => (
							<div key={`ukreport-sum-${index}`}>
								<MDBRow className="ukmrv-container mt-3">
									<MDBCol className="col-1"></MDBCol>
									<MDBCol className="col-5 pl-0">
										<label>
											<p className="label-font ml-2">
												{field.label}
											</p>
										</label>
									</MDBCol>
									{!field.remove && (
										<>
											<MDBCol className="col-2 pl-0">
												<Controller
													name={field.name}
													control={control}
													defaultValue={
														field.value || "0.00"
													}
													render={({ field }) => (
														<Input
															type={field.type}
															{...field}
															value={roundOff(
																field.value ||
																	0,
																3,
																3
															)}
															autoFocus={false}
															className="report-input-ukmrv"
															readOnly
															title={
																field.value || 0
															}
														/>
													)}
												/>
											</MDBCol>
										</>
									)}

									{userHasClaim(ClaimType.VIEW_CALCULATED_DIFF_MATERIALITY) && (
										<>
											{field.calculated && (
												<>
													<MDBCol className="col-1 pl-0">
														<Controller
															name={
																field.accessor_key_1
															}
															control={control}
															defaultValue={
																field.value ||
																"0.00"
															}
															render={({
																field,
															}) => (
																<Input
																	type={
																		field.type
																	}
																	{...field}
																	value={roundOff(
																		field.value ||
																			0,
																		3,
																		3
																	)}
																	autoFocus={
																		false
																	}
																	className="report-input-ukmrv"
																	readOnly
																	title={
																		field.value ||
																		0
																	}
																/>
															)}
														/>
													</MDBCol>
												</>
											)}
											{field.diff && (
												<>
													<MDBCol className="col-1 pl-0">
														<Controller
															name={
																field.accessor_key_2
															}
															control={control}
															defaultValue={
																field.value ||
																"0.00"
															}
															render={({
																field,
															}) => (
																<Input
																	type={
																		field.type
																	}
																	{...field}
																	value={roundOff(
																		field.value ||
																			0,
																		3,
																		3
																	)}
																	autoFocus={
																		false
																	}
																	className="report-input-ukmrv"
																	readOnly
																	title={
																		field.value ||
																		0
																	}
																/>
															)}
														/>
													</MDBCol>
												</>
											)}

											{field.materiality && (
												<>
													<MDBCol className="col-1 pl-0">
														<Controller
															name={
																field.accessor_key_3
															}
															control={control}
															defaultValue={
																field.value ||
																"0.00"
															}
															render={({
																field,
															}) => (
																<Input
																	type={
																		field.type
																	}
																	{...field}
																	value={roundOff(
																		field.value ||
																			0,
																		3,
																		3
																	)}
																	autoFocus={
																		false
																	}
																	className="report-input-ukmrv"
																	readOnly
																	title={
																		field.value ||
																		0
																	}
																/>
															)}
														/>
													</MDBCol>
												</>
											)}
										</>
									)}
								</MDBRow>
							</div>
					  ))}
			</>
		);
	};
	const tableHeader = React.useMemo(() => REPORT_SUMMMERY_HEADERS, []);
	return (
		<>
			<CustomTable
				columnsData={tableHeader}
				renderTableData={ukmrvReportSummaryTable}
				customProps={{ enableSort: false, isLoading: isLoading }}
			/>
			<form>
				<MDBRow className="uk-container mt-3">
					<MDBCol className="col-6 pl-0"></MDBCol>
					<MDBCol className="label-font col-2 ml-1">Reported</MDBCol>

					{userHasClaim(ClaimType.VIEW_CALCULATED_DIFF_MATERIALITY) && (
						<>
							<MDBCol className="label-font col-1 ml-1">
								Calculated
							</MDBCol>
							<MDBCol className="label-font col-1 ml-1">
								% Diff
							</MDBCol>
							<MDBCol className="label-font col-1 ml-1">
								5% Materiality
							</MDBCol>
						</>
					)}
				</MDBRow>
				{renderUkmrvReportData()}
			</form>
		</>
	);
};

export default UKMRVReportSummary;
